<template>
  <div>
    <el-dialog
      title="变更期望发货日期信息"
      :visible.sync="dialogVisible"
      width="1200px"
      top="15px"
      @open="open"
      @close="close"
    >
      <label style="margin-right:10px">客户期望发货日:</label>
      <el-date-picker
        v-model="wantTime"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
      />
      <el-button type="primary" style="margin-left:10px" @click="allSetGoods">
        批量设置勾选产品的期望发货日
      </el-button>
      <label style="margin-right:10px;margin-left:20px">是否接受分批发货:</label>
      <el-radio v-model="radio" label="1">
        是
      </el-radio>
      <el-radio v-model="radio" label="2">
        否
      </el-radio>
      <el-table ref="multipleTable" :data="tableData" border style="width: 100% ;margin-top:10px;margin-bottom:10px"
                :summary-method="getSummaries"
                show-summary @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />
        <el-table-column prop="itemIndex" label="序号" align="left" fixed="left" />
        <el-table-column prop="contractNum" label="合同号" align="left" />
        <el-table-column prop="materialNumber" label="物品代码" align="left" />
        <el-table-column prop="productName" label="物品名称" align="left" />
        <el-table-column prop="productNum" label="数量" align="left" />
        <el-table-column prop="productPriceSigle" label="实际结算单价" align="right" header-align="left" width="160px" />
        <el-table-column prop="settlementAmount" label="实际结算金额" align="right" header-align="left" width="160px" />
        <!-- <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" align="left" /> -->
        <el-table-column label="期望发货日期" align="left" min-width="130">
          <template v-slot="{row}">
            <el-date-picker v-model="row.expectedDeliveryDate" type="date" style="width:100%;" value-format="yyyy-MM-dd" placeholder="客户期望发货日" :clearable="false" />
          </template>
        </el-table-column>
        <el-table-column prop="agreedDate" label="约定交付日期" align="left" />
      </el-table>
      <div class="footer-btn">
        <el-button type="default" @click="close">
          取消
        </el-button>
        <el-button type="primary" :loading="loadingSub" @click="submit">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { findNotAppliedPartialShipmentList } from '@/API';
import { DateToStr } from '@/libs/util';
export default {
  data () {
    return {
      dialogVisible: this.dialogFormVisible,
      wantTime: '',
      tableData: [],
      radio: '1',
      multipleSelection: [],
      loadingSub: false
      // pickerOptions: {
      //   disabledDate: (time) => {
      //     if (this.wantTime) {
      //       let date = new Date(this.wantTime);
      //       date.setDate(date.getDate() - 1);
      //       return time.getTime() <= date.getTime();
      //     }
      //     return false;
      //   }
      // }
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
  },
  methods: {
    open () {
      this.initData();
    },
    initData () {
      findNotAppliedPartialShipmentList({ strContractCode: this.id.contractNum }).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data;
        } else {

        }
      }).catch((res) => {
      });
    },
    allSetGoods () {
      let error = '';
      if (this.multipleSelection.length > 0) {
        this.multipleSelection.forEach((item) => {
          if (this.wantTime) {
            let nowDateStr = DateToStr(new Date());
            if (new Date(this.wantTime) >= new Date(nowDateStr)) {
              item.expectedDeliveryDate = this.wantTime;
            } else {
              error = '期望发货日期不能小于当前日期';
            }
          }
        });
      } else {
        error = '请勾选期望日期';
      }

      if (error) {
        this.$notify.error({
          message: error
        });
      }
    },
    submit () {
      if (this.multipleSelection.length === 0) {
        this.$notify.error({
          message: '请选择至少一条合同'
        });
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    close () {
      this.tableData = [];
      this.radio = '1';
      this.wantTime = '';
      this.multipleSelection = [];
      this.dialogVisible = false;
    },
    // 合计
    getSummaries (param) {
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.AmountTotal();
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = this.TotalAmount();
        }
      });
      return sums;
    },
    // 数量总计
    AmountTotal () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont += item.productNum;
      });
      return cont;
    },
    // 实际结算金额合计
    TotalAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont += item.settlementAmount;
      });
      return cont;
    }
  },
  watch: {
    dialogFormVisible (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },
  mounted () {

  }

};
</script>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
